import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@env/environment';
import { AuthService, StorageService } from '../services';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith(environment.apiUrl)) {
    const authService: AuthService = inject(AuthService);
    const storageService: StorageService = inject(StorageService);
    const token = storageService.token;

    if (token && authService.isAuthenticated()) {
      const newReq = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
      return next(newReq);
    }
  }
  return next(req);
};
